import { toast } from 'react-toastify';
import { urlBaseApi as apiUrl } from '../consts';
import axios from 'axios';

const endpointUrl = apiUrl + '/uploads';

export const upload = (token, body, Type = "") => {
  // console.log("In upload")
  const MAX_FILE_SIZE_MB = Type === "SEMINAR" ? 800 : 10;
  const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;
  const file = body?.get?.('file');
// console.log("In upload",MAX_FILE_SIZE_BYTES, file.size)
  if (file && file.size > MAX_FILE_SIZE_BYTES) {
    toast.error(`File size exceeds ${MAX_FILE_SIZE_MB}MB limit.`);
    return Promise.reject(new Error(`File size exceeds ${MAX_FILE_SIZE_MB}MB limit.`));
  }

  const toastId = toast.info('Upload started...', {
    autoClose: false,
    closeButton: false,
    isLoading: true,
    closeOnClick: false,
  });

  return axios({
    url: `${endpointUrl}`,
    method: 'POST',
    data: body,
    headers: {
      Authorization: `Bearer ${token}`,
    },
    onUploadProgress: (progressEvent) => {
      const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
      console.log(`Upload progress: ${percentCompleted}%`);

      // Update the toast with progress
      toast.update(toastId, {
        render: `Uploading: ${percentCompleted}%`,
        isLoading: true,
      });
    }
  })
  .then(response => {
    toast.update(toastId, {
      render: 'Upload complete!',
      type: 'success',
      isLoading: false,
      autoClose: 3000,
      closeButton: true,
    });
    return response;
  })
  .catch(error => {
    toast.update(toastId, {
      render: 'Upload failed!',
      type: 'error',
      isLoading: false,
      autoClose: 5000,
      closeButton: true,
    });
    return Promise.reject(error);
  });
};
